import { render, staticRenderFns } from "./restoreComponent.vue?vue&type=template&id=57fb53b6&scoped=true"
import script from "./restoreComponent.vue?vue&type=script&lang=js"
export * from "./restoreComponent.vue?vue&type=script&lang=js"
import style0 from "./restoreComponent.vue?vue&type=style&index=0&id=57fb53b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57fb53b6",
  null
  
)

export default component.exports